document.documentElement.classList.remove('no-js');

const header = document.querySelector('[data-site-header]');
const toggle = document.querySelector('[data-menu-toggle]');
const mobileMenu = document.querySelector('[data-mobile-menu]');
const backToTop = document.querySelector('[data-back-to-top]');

function closeMenu() {
  if (!toggle || !mobileMenu) return;
  toggle.setAttribute('aria-expanded', 'false');
  mobileMenu.hidden = true;
  const menuLabel = toggle.querySelector('em');
  if (menuLabel) menuLabel.textContent = 'Abrir menu';
  document.body.classList.remove('menu-open');
}

if (toggle && mobileMenu) {
  toggle.addEventListener('click', () => {
    const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(willOpen));
    mobileMenu.hidden = !willOpen;
    const menuLabel = toggle.querySelector('em');
    if (menuLabel) menuLabel.textContent = willOpen ? 'Fechar menu' : 'Abrir menu';
    document.body.classList.toggle('menu-open', willOpen);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !mobileMenu.hidden) { closeMenu(); toggle.focus(); }
  });

  mobileMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
  window.addEventListener('resize', () => {
    if (window.innerWidth > 1240) closeMenu();
  });
}

function updateHeader() {
  if (header) header.classList.toggle('is-scrolled', window.scrollY > 16);
  if (backToTop) backToTop.hidden = window.scrollY < 700;
}

updateHeader();
window.addEventListener('scroll', updateHeader, { passive: true });

if (backToTop) {
  backToTop.addEventListener('click', () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  });
}

document.querySelectorAll('.faq-list details').forEach((item) => {
  item.addEventListener('toggle', () => {
    if (!item.open) return;
    document.querySelectorAll('.faq-list details[open]').forEach((openItem) => {
      if (openItem !== item) openItem.removeAttribute('open');
    });
  });
});

document.querySelectorAll('form').forEach((form) => {
  form.addEventListener('submit', (event) => {
    const honeypot = form.querySelector('.honeypot input');
    if (honeypot && honeypot.value.trim()) event.preventDefault();
  });

  const requiredFields = [...form.querySelectorAll('input[required], select[required], textarea[required]')];
  const errorMessage = (field) => {
    if (field.validity.typeMismatch) return 'Informe um e-mail válido.';
    if (field.validity.tooLong) return `Use no máximo ${field.maxLength} caracteres.`;
    if (field.validity.valueMissing) return field.type === 'checkbox' ? 'Marque esta opção para continuar.' : 'Preencha este campo.';
    return 'Confira o valor informado.';
  };
  const errorTarget = (field) => field.closest('.consent, .newsletter-consent') || field.closest('.field') || field;
  const validateField = (field) => {
    if (!field.id) return field.validity.valid;
    const errorId = `${field.id}-error`;
    const describedBy = new Set((field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
    let error = form.querySelector(`#${errorId}`);
    if (field.validity.valid) {
      field.removeAttribute('aria-invalid');
      if (field.getAttribute('aria-errormessage') === errorId) field.removeAttribute('aria-errormessage');
      describedBy.delete(errorId);
      if (describedBy.size) field.setAttribute('aria-describedby', [...describedBy].join(' '));
      else field.removeAttribute('aria-describedby');
      error?.remove();
      return true;
    }
    field.setAttribute('aria-invalid', 'true');
    field.setAttribute('aria-errormessage', errorId);
    describedBy.add(errorId);
    field.setAttribute('aria-describedby', [...describedBy].join(' '));
    if (!error) {
      error = document.createElement('span');
      error.id = errorId;
      error.className = 'field-error';
      error.setAttribute('role', 'alert');
      errorTarget(field).insertAdjacentElement('afterend', error);
    }
    error.textContent = errorMessage(field);
    return false;
  };

  requiredFields.forEach((field) => {
    field.addEventListener('blur', () => validateField(field));
    field.addEventListener(field.type === 'checkbox' || field.tagName === 'SELECT' ? 'change' : 'input', () => {
      if (field.hasAttribute('aria-invalid')) validateField(field);
    });
  });
  form.addEventListener('invalid', (event) => validateField(event.target), true);
});

const focusableSelector = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'iframe',
  '[tabindex]:not([tabindex="-1"])'
].join(',');

function trapFocus(event, container) {
  if (event.key !== 'Tab' || !container) return;
  const focusableElements = [...container.querySelectorAll(focusableSelector)].filter((element) =>
    element.getClientRects().length > 0 && !element.closest('[hidden], [inert]') && element.getAttribute('aria-hidden') !== 'true'
  );
  if (!focusableElements.length) {
    event.preventDefault();
    container.focus();
    return;
  }
  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];
  if (event.shiftKey && document.activeElement === firstElement) {
    event.preventDefault();
    lastElement.focus();
  } else if (!event.shiftKey && document.activeElement === lastElement) {
    event.preventDefault();
    firstElement.focus();
  }
}

document.querySelectorAll('.erp-dialog').forEach((dialog) => {
  let returnFocusElement = null;
  const closeButton = dialog.querySelector('.erp-dialog-close');
  const closeDialog = () => {
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else {
      dialog.removeAttribute('open');
      document.body.classList.remove('erp-dialog-open');
      returnFocusElement?.focus?.();
    }
  };

  document.querySelectorAll(`[data-erp-dialog-open="${dialog.id}"]`).forEach((trigger) => {
    trigger.addEventListener('click', () => {
      returnFocusElement = trigger;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      document.body.classList.add('erp-dialog-open');
      closeButton?.focus();
    });
  });

  closeButton?.addEventListener('click', (event) => {
    event.preventDefault();
    closeDialog();
  });
  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeDialog();
  });
  dialog.addEventListener('close', () => {
    document.body.classList.remove('erp-dialog-open');
    returnFocusElement?.focus?.();
  });
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeDialog();
  });
  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDialog();
      return;
    }
    trapFocus(event, dialog);
  });
});

const articleContent = document.querySelector('[data-article-content]');
const articleToc = document.querySelector('[data-article-toc]');

if (articleContent) {
  const signupTemplate = document.querySelector('[data-article-mid-signup]');
  const contentBlocks = [...articleContent.children].filter((element) =>
    !['SCRIPT', 'STYLE'].includes(element.tagName)
  );

  if (signupTemplate && contentBlocks.length >= 3) {
    const targetIndex = Math.max(0, Math.ceil(contentBlocks.length / 2) - 1);
    contentBlocks[targetIndex].after(signupTemplate.content.cloneNode(true));
  }
}

if (articleContent && articleToc) {
  const headings = [...articleContent.querySelectorAll('h2, h3')];
  if (headings.length > 1) {
    const tocNav = articleToc.querySelector('nav');
    const usedIds = new Set();
    headings.forEach((heading, index) => {
      let baseId = heading.id || heading.textContent
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '') || `secao-${index + 1}`;
      let headingId = baseId;
      let suffix = 2;
      while (usedIds.has(headingId)) headingId = `${baseId}-${suffix++}`;
      usedIds.add(headingId);
      heading.id = headingId;

      const link = document.createElement('a');
      link.href = `#${headingId}`;
      link.textContent = heading.textContent;
      if (heading.tagName === 'H3') link.classList.add('toc-level-3');
      tocNav.appendChild(link);
    });
    articleToc.hidden = false;
  }
}

document.querySelectorAll('[data-copy-url]').forEach((button) => {
  button.addEventListener('click', async () => {
    const url = button.dataset.copyUrl || window.location.href;
    try {
      await navigator.clipboard.writeText(url);
    } catch (_) {
      const input = document.createElement('textarea');
      input.value = url;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }
    const notice = document.createElement('div');
    notice.className = 'copy-confirmation';
    notice.setAttribute('role', 'status');
    notice.textContent = 'Link copiado.';
    document.body.appendChild(notice);
    setTimeout(() => notice.remove(), 2200);
  });
});

document.querySelector('[data-form-status]')?.focus();
